const hasOnline = window.location.href.indexOf('lixiang') > 0;
export default class DomainNameConst {
    // 本地
    /*  public static login = {
         production: '/chjhmi/aisp-sso-api/v1-0/pc/sso',
         development: '/chjhmi/aisp-sso-api/v1-0/pc/sso',
     };
     public static article = {
         production: '/chjhmi/aisp-community-api/v1-0/article',
         development: '/chjhmi/aisp-community-api/v1-0/article',
     };
     public static communityComm = {
         production: '/chjhmi/aisp-community-api/v1-0/comm',
         development: '/chjhmiaisp-community-api/v1-0/comm',
     };
     public static oisSts = {
         production: '/chjhmi/chehejia-service-ois-app/ois/v1/sts',
         development: '/chjhmi/chehejia-service-ois-app/ois/v1/sts',
     };
     public static getEnv() {
         if (process && process.env.NODE_ENV === 'development') {
             return 'development';
         } else {
             let env = 'production';
             if (window.location.hostname.split('.').length > 0) {
                 const hostname = window.location.hostname.split('.')[0];
                 if (hostname.indexOf('-') > -1) {
                     env = hostname.substring(hostname.indexOf('-') + 1);
                     // env = 'testing'
                 }
                 if (hostname.indexOf('mobilesh') > -1) {
                     env = 'sh';
                 }
             }
             return env;
         }
     } */
    // 本地
    public static apigetway_local = {
        prod: '/prod-api',
        dev: '/dev-api',
        test: '/test-api',
        ontest: '/ontest-api'
    };
    // apigetway
    public static apigetway_online = {
        prod: 'https://api-web.lixiang.com',
        dev: 'https://iot-api-web-dev.lixiang.com',
        test: 'https://iot-api-web-test.lixiang.com',
        ontest: 'https://iot-api-web-ontest-b.lixiang.com'
    };

    public static apigetway = () => {
        if (hasOnline) {
            return DomainNameConst.apigetway_online;
        } else {
            return DomainNameConst.apigetway_local;
        }
    };
    // idaas 域名

    public static idaas_online = {
        prod: 'https://id.lixiang.com',
        dev: 'https://id-ontest.lixiang.com',
        test: 'https://id-ontest.lixiang.com',
        ontest: 'https://id-ontest.lixiang.com'
    };
    public static getIdaas(): string {
        return DomainNameConst.idaas_online[DomainNameConst.getEnv()];
    }
    // 外网
    public static login = {
        prod: DomainNameConst.apigetway()['prod'] + '/aisp-account-api/v1-0',
        dev: DomainNameConst.apigetway()['dev'] + '/aisp-account-api/v1-0',
        test: DomainNameConst.apigetway()['ontest'] + '/aisp-account-api/v1-0',
        ontest: DomainNameConst.apigetway()['ontest'] + '/aisp-account-api/v1-0'
    };
    public static article = {
        prod:
            DomainNameConst.apigetway()['prod'] +
            '/aisp-community-api/v1-0/article',
        dev:
            DomainNameConst.apigetway()['dev'] +
            '/aisp-community-api/v1-0/article',
        test:
            // DomainNameConst.apigetway()['test'] +
            // '/aisp-community-api/v1-0/article',
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/article',
        ontest:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/article'
    };
    public static question = {
        prod: DomainNameConst.apigetway()['prod'] + '/aisp-community-api/v1-0',
        dev: DomainNameConst.apigetway()['dev'] + '/aisp-community-api/v1-0',
        test: DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v1-0',
        ontest:
            DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v1-0'
    };
    public static getdetail = {
        prod: DomainNameConst.apigetway()['prod'] + '/aisp-community-api/v2-0',
        dev: DomainNameConst.apigetway()['dev'] + '/aisp-community-api/v2-0',
        test: DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v2-0',
        ontest:
            DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v2-0'
    };
    public static question_ver2 = {
        prod: DomainNameConst.apigetway()['prod'] + '/aisp-community-api/v2-0',
        dev: DomainNameConst.apigetway()['dev'] + '/aisp-community-api/v2-0',
        test: DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v2-0',
        ontest:
            DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v2-0'
    };
    public static question_v2 = {
        prod: DomainNameConst.apigetway()['prod'] + '/aisp-community-api/v3-0',
        dev: DomainNameConst.apigetway()['dev'] + '/aisp-community-api/v3-0',
        test: DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v3-0',
        ontest:
            DomainNameConst.apigetway()['ontest'] + '/aisp-community-api/v3-0'
    };
    public static video = {
        prod:
            DomainNameConst.apigetway()['prod'] +
            '/aisp-community-api/v1-0/video',
        dev:
            DomainNameConst.apigetway()['dev'] +
            '/aisp-community-api/v1-0/video',
        test:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/video',
        ontest:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/video'
    };
    public static communityComm = {
        prod:
            DomainNameConst.apigetway()['prod'] +
            '/aisp-community-api/v1-0/comm',
        dev:
            DomainNameConst.apigetway()['dev'] +
            '/aisp-community-api/v1-0/comm',
        test:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/comm',
        ontest:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0/comm'
    };
    public static oisSts = {
        prod:
            'https://api-boss-public.chehejia.com' +
            '/chehejia-service-ois-app/ois/v1/sts',
        dev:
            DomainNameConst.apigetway()['dev'] +
            '/chehejia-service-ois-app/ois/v1/sts',
        test:
            DomainNameConst.apigetway()['ontest'] +
            '/chehejia-service-ois-app/ois/v1/sts',
        ontest:
            DomainNameConst.apigetway()['ontest'] +
            '/chehejia-service-ois-app/ois/v1/sts'
    };
    // oas
    public static oasSts = {
        prod: 'https://api-web.lixiang.com' + '/icn-oas-api/v1',
        // dev:
        //     DomainNameConst.apigetway()['dev'] +
        //     '/icn-oas-api/v1',
        test: 'https://iot-api-web-ontest-b.lixiang.com' + '/icn-oas-api/v1',
        ontest: 'https://iot-api-web-ontest-b.lixiang.com' + '/icn-oas-api/v1'
    };
    public static community = {
        prod:
            DomainNameConst.apigetway()['prod'] +
            '/aisp-community-api/v1-0',
        dev:
            DomainNameConst.apigetway()['dev'] +
            '/aisp-community-api/v1-0',
        test:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0',
        ontest:
            DomainNameConst.apigetway()['ontest'] +
            '/aisp-community-api/v1-0'
    };
    public static getEnv() {
        if (window['serverEnv']) {
            return window['serverEnv'];
        }
        window['localEnv'] = 'test';
        return window['localEnv'];
    }

    public static getOisSts(): string {
        return DomainNameConst.oisSts[DomainNameConst.getEnv()];
    }
    // oas新接口
    public static getOasSts(): string {
        return DomainNameConst.oasSts[DomainNameConst.getEnv()];
    }
    public static getLogin(): string {
        return DomainNameConst.login[DomainNameConst.getEnv()];
    }
    public static getArticle(): string {
        return DomainNameConst.article[DomainNameConst.getEnv()];
    }
    public static getcommunityComm(): string {
        return DomainNameConst.communityComm[DomainNameConst.getEnv()];
    }
    public static getQuestion(): string {
        return DomainNameConst.question[DomainNameConst.getEnv()];
    }
    public static getQuestion_ver2(): string {
        return DomainNameConst.question_ver2[DomainNameConst.getEnv()];
    }

    // 文章详情接口升级v-2 备用
    public static getDetail_2(): string {
        return DomainNameConst.getdetail[DomainNameConst.getEnv()];
    }
    public static getQuestion_v2(): string {
        return DomainNameConst.question_v2[DomainNameConst.getEnv()];
    }
    public static getVideo(): string {
        return DomainNameConst.video[DomainNameConst.getEnv()];
    }
    public static getCommunity(): string {
        return DomainNameConst.community[DomainNameConst.getEnv()];
    }
}
